import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Header from '../sections/Header';
import AboutTC from '../sections/AboutTC';
import WhoJoinTC from '../sections/WhoJoinTC';
import { GeneralCardsSection } from '../sections/Cards';
import ActionCards, { Banners } from '../sections/ActionCards';
import { ProgrammePostWalesSection } from '../sections/CardsSections';

import placeholderData from '../utils/placeholderData';

import { navRoutes } from '../constants';

const spendWalesEnglish = [
  {
    title: 'Cadw',
    description: 'Experience the inspiring castles and abbeys that Cadw looks after',
    imageInfo: 'cadw',
  },
  {
    title: 'The Royal Mint Experience',
    description: 'Learn how the coins and medals for almost 60 countries are made',
    imageInfo: 'theRoyalMintExperience',
  },
  {
    title: 'BikePark Wales',
    description: 'Get mountain biking in the heart of the South Wales valleys',
    imageInfo: 'bikeparkWales',
  },
  {
    title: 'Plantasia',
    description: 'Grow your imagination at this immersive tropical experience',
    imageInfo: 'plantasia',
  },
  {
    title: 'Techniquest',
    description: 'The UK’s longest established science centre – great for all the family',
    imageInfo: 'techniquest',
  },
  {
    title: 'Parc y Scarlets',
    description: 'Support the Scarlets, one of the four professional Welsh rugby union teams',
    imageInfo: 'parcYScarlets',
  },
];

export const TempoTimeCreditsWalesEnglishTemplate = ({
  whatTcSubtitle,
  whatTcDescription,
  whatTcInWalesSubtitle,
  whatTcInWalesDescription,
  whocanJoinTcInWalesTitle,
  whocanJoinTcInWalesSubtitle1,
  whocanJoinTcInWalesDescription1,
  whocanJoinTcInWalesSubtitle2,
  whocanJoinTcInWalesDescription2,
  programmesPostsTitle,
  preview,
}) => {
  return (
    <>
      <Header
        page="timeCreditsWalesEnglish"
        title="Tempo Time Credits in Wales&nbsp;/&nbsp;Credydau Amser Tempo yng Nghymru"
      />
      <AboutTC
        darkBG
        title="What are Tempo Time Credits?"
        boldParagraph={whatTcSubtitle}
        lightParagraph={whatTcDescription}
        to={navRoutes.FAQs}
      />
      <AboutTC
        title="Tempo Time Credits in Wales"
        boldParagraph={whatTcInWalesSubtitle}
        lightParagraph={whatTcInWalesDescription}
        to={navRoutes.aboutUs}
        buttonText="Read more about Tempo"
      />

      <WhoJoinTC
        language="english"
        title={whocanJoinTcInWalesTitle}
        subTitleTop={whocanJoinTcInWalesSubtitle1}
        descriptionTop={whocanJoinTcInWalesDescription1}
        subTitleBottom={whocanJoinTcInWalesSubtitle2}
        descriptionBottom={whocanJoinTcInWalesDescription2}
      />

      <GeneralCardsSection
        data={spendWalesEnglish}
        type="spendPostsWalesEnglish"
        title="Where can people spend Time Credits in Wales?"
      />
      <Banners type="TCWalesEnglish" />
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="programmes"
          title={programmesPostsTitle}
        />
      ) : (
        <ProgrammePostWalesSection title={programmesPostsTitle} />
      )}
      <ActionCards language="english" />
    </>
  );
};

const TempoTimeCreditsWalesEnglishPage = ({
  data: {
    markdownRemark: { frontmatter },
  },
}) => {
  return (
    <Layout>
      <TempoTimeCreditsWalesEnglishTemplate {...frontmatter} />
    </Layout>
  );
};
export const TempoTimeCreditsWalesEnglishQuery = graphql`
  query TempoTimeCreditsWalesEnglishQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        whatTcSubtitle
        whatTcDescription
        whatTcInWalesSubtitle
        whatTcInWalesDescription
        whocanJoinTcInWalesTitle
        whocanJoinTcInWalesSubtitle1
        whocanJoinTcInWalesDescription1
        whocanJoinTcInWalesSubtitle2
        whocanJoinTcInWalesDescription2
        programmesPostsTitle
      }
    }
  }
`;

export default TempoTimeCreditsWalesEnglishPage;
